import { formatInTimeZone } from 'date-fns-tz';

/**
 * Format SMS date time with clinic timezone
 */
export const formatSMSDateTime = (dateTime: string, clinicTimezone?: string): string => {
  const dateTimeWithZ = dateTime.endsWith('Z') ? dateTime : `${dateTime}Z`;
  const date = new Date(dateTimeWithZ);
  const timezone = clinicTimezone || 'UTC';
  
  try {
    return formatInTimeZone(date, timezone, 'MMM dd, yyyy hh:mm aa');
  } catch (error) {
    // Fallback to local time if timezone is invalid
    return date.toLocaleString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }
};

/**
 * Format phone number for display
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return '';
  
  // Remove any non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, '');
  
  // Format as (XXX) XXX-XXXX if it's a 10-digit US number
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  
  // Return as-is if not a standard format
  return phoneNumber;
};

/**
 * Get display value with fallback for empty or null values
 */
export const getDisplayValue = (value: string | null | undefined, fallback: string = '-'): string => {
  return value && value.trim() ? value.trim() : fallback;
};